import React, { useEffect, useRef, useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StatisticCard from "./components/StatisticCard";
import Casa from "./assets/Casa.gif"; 
import Piscina from "./assets/Piscina.gif"; 
import Caminhao from "./assets/Caminhao.gif"; 
import CampodeFutebol from "./assets/campo-de-futebol.gif"; 
import {MdFoundation, MdPool, MdPark, MdRecycling} from "react-icons/md";

const REFRESH_INTERVAL_MS = 10 * 60 * 1000;

const App = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasLoadedDataRef = useRef(false);
  const isFetchingRef = useRef(false);
  const apiBaseUrl = (process.env.REACT_APP_API_URL || "")
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .replace(/\/$/, "");
  const dataEndpoint = apiBaseUrl ? `${apiBaseUrl}/data` : "/data";

  useEffect(() => {
    let isActive = true;

    const fetchData = async () => {
      if (isFetchingRef.current) {
        return;
      }

      isFetchingRef.current = true;

      try {
        const response = await fetch(dataEndpoint, { cache: "no-store" });

        if (!response.ok) {
          throw new Error("Erro na resposta da rede");
        }

        const nextData = await response.json();

        if (!isActive) {
          return;
        }

        console.log("Dados recebidos:", nextData);
        hasLoadedDataRef.current = true;
        setData(nextData);
        setError(null);
        setLoading(false);
      } catch (nextError) {
        console.error("Erro ao buscar dados:", nextError);

        if (!isActive || hasLoadedDataRef.current) {
          return;
        }

        setError(nextError);
        setLoading(false);
      } finally {
        isFetchingRef.current = false;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        fetchData();
      }
    };

    fetchData();

    const intervalId = window.setInterval(fetchData, REFRESH_INTERVAL_MS);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      isActive = false;
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dataEndpoint]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Erro: {error.message}</div>;

  const kgResiduosFormated = data.kgResiduos / 1000;

  function formatNumber(value) {
    return new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  return (
    <div className="flex flex-col min-h-screen bg-custom-gradient">
      <Header />
      <div className="flex-grow px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-36 mt-16 justify-items-center">
          <StatisticCard
            title="Metros Quadrado Construído"
            value={`${formatNumber(data.m2Construido)}`}
            equivalent={`${data.qtdCasas}` }
            segundaParte={"de 250m²"}
            gif={Casa}
            bgcolor={"quinary"}
            icon={<MdFoundation size={40} />}
          />
          <StatisticCard
            title="Litros de Água Não Utilizada"
            value={`${formatNumber(data.totalLitros)}`}
            equivalent={`${data.qtdPiscinas}`}
            segundaParte={"piscinas olímpicas"}
            gif={Piscina}
            bgcolor={"piscina"}
            className="bg-piscina"
            icon={<MdPool size={40} />}
          />
          <StatisticCard
            title="Unidades de Árvores Preservadas"
            value={`${formatNumber(data.qtdArvores)}`}
            equivalent={`${data.qtdCamposDeFutebol}`}
            segundaParte={"campos de futebol"}
            gif={CampodeFutebol}
            bgcolor={"campo"}
            className="bg-campo"
            icon={<MdPark size={40} />}
          />
          <StatisticCard
            title="Toneladas de Resíduos Não Gerados"
            value={`${formatNumber(kgResiduosFormated)}`}
            decimal={true}
            equivalent={`${data.qtdCacambas}`}
            segundaParte={"caçambas de lixo"}
            gif={Caminhao}
            bgcolor={"residuos"}
            className="bg-residuos"
            icon={<MdRecycling size={40} />}
          />
        </div>
      </div>
      <div className="pb-10 footer-bg-custom">
        <Footer />
      </div>
    </div>
  );
};

export default App;
